import api from 'Common/Client/Interceptor';

export const certificateService = {
  getLearnerCertificates: async (pageNumber = 1, pageSize = 6, orderByLatest = true) => {
    try {
      const response = await api.get('/indv/Certification/Get-LearnerCerts', {
        params: {
          PageNumber: pageNumber,
          PageSize: pageSize,
          OrderByLatest: orderByLatest
        }
      });
      console.log("Certificates data:", response.data);
      return response.data;
    } catch (error) {
      console.error('Error fetching certificates:', error);
      throw error;
    }
  },

  getCertificateById: async (certificateId) => {
    try {
      const response = await api.get(`/indv/Certification/Get-Detail/${certificateId}`);
      return response.data;
    } catch (error) {
      throw error;
    }
  }
};
